import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserRegistration = {
  userRegistration: { data: null, loading: false, error: null },
};

export const userRegistration = createAsyncThunk('user/userRegistration', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/registration`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserRegistration = {
  [userRegistration.pending]: (state) => {
    state.userRegistration.loading = true;
  },
  [userRegistration.fulfilled]: (state, action) => {
    state.userRegistration.loading = false;
    state.userRegistration.data = action.payload;
    state.userRegistration.error = null;
  },
  [userRegistration.rejected]: (state, action) => {
    state.userRegistration.loading = false;
    state.userRegistration.error = action.payload;
  },
};
